import { computed } from 'vue';
import { useStore } from 'vuex';

export function viewPermissions(rawPermissionKey: string | string[]) {
  const store = useStore();

  const permissionKey = computed(() => {
    if (typeof rawPermissionKey === 'string') {
      return rawPermissionKey.split(',').map(p => p.trim());
    }
    return Array.isArray(rawPermissionKey) ? rawPermissionKey : [];
  });

  const foundPermissions = computed(() => {
    return permissionKey.value.filter(p =>
      store.state.userVaultnPermissions.includes(p)
    );
  });

  const viewRbac = computed(() => {
    return foundPermissions.value.length > 0;
  });

  return {
    permissionKey,
    foundPermissions,
    viewRbac,
  };
}